var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.694,
    height: 10.579,
    viewBox: "0 0 12.694 10.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Twitter",
    d: "M312.694,165.252a5.088,5.088,0,0,1-1.5.42,2.665,2.665,0,0,0,1.145-1.477,5.129,5.129,0,0,1-1.655.647,2.568,2.568,0,0,0-1.9-.843,2.638,2.638,0,0,0-2.6,2.67,2.726,2.726,0,0,0,.067.608,7.332,7.332,0,0,1-5.368-2.791,2.719,2.719,0,0,0-.352,1.344,2.688,2.688,0,0,0,1.159,2.223,2.557,2.557,0,0,1-1.18-.333v.033a2.655,2.655,0,0,0,2.09,2.618,2.483,2.483,0,0,1-.686.094,2.53,2.53,0,0,1-.49-.047,2.614,2.614,0,0,0,2.433,1.854,5.143,5.143,0,0,1-3.234,1.144,5.21,5.21,0,0,1-.621-.037,7.251,7.251,0,0,0,3.992,1.2,7.46,7.46,0,0,0,7.41-7.6c0-.116,0-.232-.007-.346a5.345,5.345,0,0,0,1.3-1.382",
    transform: "translate(-300 -164)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5c0c77f1.svg";
export { ForwardRef as ReactComponent };